import { render, staticRenderFns } from "./BetsTool.vue?vue&type=template&id=0224d5ad&scoped=true&"
import script from "./BetsTool.vue?vue&type=script&lang=js&"
export * from "./BetsTool.vue?vue&type=script&lang=js&"
import style0 from "./BetsTool.vue?vue&type=style&index=0&id=0224d5ad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0224d5ad",
  null
  
)

export default component.exports